import React, { useRef, useState, useEffect } from "react";
import '../../assets/styles/imageUpload.scss';
import cloudUpload from '../../assets/images/cloud-upload.svg';
import { showToast } from './toast';
import { TOAST_TYPE, FEATURE_MSG } from '../../constants/toast';

function ImageUpload({
  maxFileSize = 100000,
  onFileSelect,
  uploadLabel,
  previewLabel,
  resetTrigger,
  description,
  isFavicon = false,
  logopreview
}) {
  const [previewUrl, setPreviewUrl] = useState();
  const [isDragging, setIsDragging] = useState(false);
  const fileInputRef = useRef(null);

  useEffect(() => {
    if (resetTrigger !== undefined) {
      const res = `${logopreview}?v=${resetTrigger}`
      setPreviewUrl(res);
      if (fileInputRef.current) {
        fileInputRef.current.value = "";
      }
    }
  }, [resetTrigger]);

  const handleFileValidation = (file) => {
    if (file.size > maxFileSize) {
      showToast(
        TOAST_TYPE.ERROR,
        `${FEATURE_MSG.SYSTEM_SETTINGS.FILE_TOO_LARGE} ${maxFileSize / 1000}KB`
      );
      return false;
    }

    const validTypes = isFavicon
      ? ["image/x-icon", "image/vnd.microsoft.icon"]
      : ["image/jpeg", "image/png", "image/svg+xml"];

    if (!validTypes.includes(file.type)) {
      showToast(
        TOAST_TYPE.ERROR,
        isFavicon
          ? FEATURE_MSG.SYSTEM_SETTINGS.ICO_FILE_TYPE
          : FEATURE_MSG.SYSTEM_SETTINGS.INVALID_FILE_TYPE
      );
      return false;
    }

    return true;
  };

  const handleFileSelect = (file) => {
    if (!handleFileValidation(file)) {
      return;
    }

    // Create preview
    const reader = new FileReader();
    reader.onloadend = () => {
      setPreviewUrl(reader.result);
    };
    reader.readAsDataURL(file);

    if (onFileSelect) {
      onFileSelect(file);
    }
  };

  const handleInputChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      handleFileSelect(file);
      // Reset input value to allow selecting the same file again
      e.target.value = "";
    }
  };

  const handleContainerClick = () => {
    fileInputRef.current?.click();
  };

  const handleDragOver = (e) => {
    e.preventDefault();
    e.stopPropagation();
    setIsDragging(true);
  };

  const handleDragLeave = (e) => {
    e.preventDefault();
    e.stopPropagation();
    setIsDragging(false);
  };

  const handleDrop = (e) => {
    e.preventDefault();
    e.stopPropagation();
    setIsDragging(false);

    const file = e.dataTransfer.files[0];
    if (file) {
      handleFileSelect(file);
    }
  };

  return (
    <div className="w-full h-full ">
      <div className="md:flex flex-col mb-3">
        <div className="md:col-8 ">
          <p className="text-sm">{uploadLabel}</p>
          <div
            className={`w-full image-upload-container ${isDragging ? "dragging" : ""
              }`}
            onClick={handleContainerClick}
            onDragOver={handleDragOver}
            onDragLeave={handleDragLeave}
            onDrop={handleDrop}
          >
            <input
              ref={fileInputRef}
              type="file"
              accept={isFavicon ? ".ico" : "image/jpeg,image/png,image/svg+xml"}
              onChange={handleInputChange}
              style={{ display: "none" }}
            />
            <div className="image-upload-div">
              <img className="mb-4" src={cloudUpload} alt="" />
              <p className="md:text-lg text-sm font-medium m-0">Drag files here or click to upload</p>
              <p className="text-xs">{description}</p>
            </div>
          </div>
        </div>
        <div className="md:col-4">
          <p className="text-sm">{previewLabel}</p>
          <div className="w-full image-upload-container">
            <div
              className="w-full h-full"
              style={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              {previewUrl ? (
                <img
                  src={previewUrl}
                  alt="Logo Preview"
                  style={{
                    objectFit: "contain",
                    width: "100%",
                    height: "100%",
                  }}
                />
              ) : (
                <p className="text-xs" style={{ color: "#cbd5e0" }}>
                  No logo selected
                </p>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default ImageUpload;
